<!--<div *ngIf="dashboardKPIService.isLoading" class="loading-box">-->
<!--    <i class="fa fa-spinner fa-spin"></i>&nbsp; Loading KPIs-->
<!--</div>-->

<div *ngIf="metrics && metrics.length > 0" class="component-wrapper">
  <div *ngFor="let metric of metrics; let mi = index">
    <!--    <div class="metric-group">-->
    <!--      <span class="metric-group-name">{{monthlyMetric.groupName}}</span> &nbsp; <span class="metric-date-range">-->
    <!--                    {{ currentStartDate | datex:'ddd DD MMM YYYY' }}  -  {{ currentEndDate | datex:'ddd DD MMM YYYY' }}-->
    <!--                </span>-->
    <!--    </div>-->

    <div class="chart-container">
      <p-header>
        <div
          style="
            text-align: center;
            font-size: 16px;
            font-weight: 500;
            padding-top: 5px;
            padding-bottom: 4px;
            margin-top: 5px;
          "
        >
          {{ metric.title }}
          <span class="chart-loading" *ngIf="dashboardKPIService.isLoading"
            ><i class="fa fa-spinner fa-spin"></i>&nbsp; Loading...</span
          >
        </div>

        <div *ngIf="!metric.data || metric.data.length == 0">
          <div class="no-data">No Data for the current date-range/filter selection</div>
        </div>
      </p-header>

      <p-chart
        [type]="metric.chartData?.chartType"
        [data]="metric.chartData"
        [height]="500"
        [options]="metric.chartData?.options"
        [plugins]="this.plugin"
      ></p-chart>

      <p-footer>
        <!-- display first metric as current -->
        <div class="stats-wrapper" *ngIf="metric?.data?.length > 0">
          <div class="monthly-metric overflow-x-table">
            <table class="metric-table table-striped">
              <thead>
                <tr>
                  <th *ngFor="let header of metric.headers">
                    {{ header }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of metric.tableData">
                  <td *ngFor="let column of metric.headers; let i = index">
                    <span *ngIf="data[i]?.type == ValueType.Date">{{
                      data[i].value | datex : "ddd DD MMM 'YY"
                    }}</span>
                    <span *ngIf="data[i]?.type == ValueType.Number">{{
                      data[i].value | number
                    }}</span>
                    <span *ngIf="data[i]?.type == ValueType.Percent">{{
                      data[i].value + '%'
                    }}</span>
                    <span *ngIf="data[i]?.type == ValueType.String">{{ data[i].value }}</span>
                  </td>
                </tr>
                <tr class="totals-row">
                  <!-- totals row -->
                  <td *ngFor="let column of metric.totalsRow; let i = index">
                    <span>{{ column }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="clear: both"></div>
      </p-footer>
    </div>
  </div>
</div>
